module.exports = __webpack_public_path__ + "img/img-vpower-d.564caeed.png";